import { addToCart } from '~/js/lib/cart'; // eslint-disable-line

export default (node) => {
  /**
   * Data + elements
   */
  const swiperContainer = node.querySelector('.swiper-container');
  const buttonNext = node.querySelector('[data-next]');
  const buttonPrev = node.querySelector('[data-prev]');
  const allColors = node.querySelectorAll('[data-option-color]');
  const addToCartButton = node.querySelector('[data-add-to-cart-button]');
  const productHandle = addToCartButton?.dataset.productHandle;
  const locale = addToCartButton?.dataset.locale;
  const language = locale === 'fr' ? '/fr' : '';
  let productCardSwiper = null;
  /**
   * Functions
   */
  const initSwiper = () => {
    productCardSwiper = new Swiper(swiperContainer, {
      spaceBetween: 20,
      grabCursor: true,
      slidesPerView: 1,
      allowTouchMove: true,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      breakpoints: {
        768: {
          grabCursor: false,
          allowTouchMove: false,
        },
      },
      on: {
        init: () => {
          setTimeout(() => {
            swiperContainer.classList.remove('opacity-0');
          }, 300);
        },
      },
    });

    productCardSwiper.on('click', (slide, event) => {
      // only enable the click event on desktop > 768px
      // const slideActive = productCardSwiper.slides[productCardSwiper.realIndex];

      // if (window.innerWidth > 768) {
      //   // window.location.href = productCardUrl;
      //   if (event.ctrlKey || event.metaKey) {
      //     // Ctrl (Windows/Linux) or Command (Mac)
      //     // open in new tab
      //     window.open(slideActive.dataset.imageVariant, "_blank");
      //   } else {
      //     // Normal click (open in same tab, optional)
      //     // open in same tab
      //     window.location.href = slideActive.dataset.imageVariant;
      //   }
      // } else {
      //   window.location.href = slideActive.dataset.imageVariant;
      // }
    });

    productCardSwiper.on('slideChange', (slide) => {
      const slideActive = productCardSwiper.slides[productCardSwiper.realIndex];
      const variantId = slideActive.dataset.imageVariant;
      const allUrls = node.querySelectorAll('[data-product-url]');
      allUrls.forEach((url) => {
        url.href = variantId;
      });
    });
  };

  const handleColorClick = (e) => {
    const elementSelected = e.currentTarget;
    const selectedColor = elementSelected.dataset.optionColor;
    const selectedImage = node.querySelector(
      `[data-image-option="${selectedColor}"]`
    );

    let currentVariantId = null;

    // update prices
    const regularPrice = node.querySelector('[data-product-card-regular-price]');
    const compareAtPrice = node.querySelector('[data-product-card-compare-price]');
    // compareAtPrice.textContent = elementSelected.dataset.optionCompareAtPrice;
    // regularPrice.textContent = elementSelected.dataset.optionPrice;

    if (selectedImage) {
      const variantId = selectedImage.dataset.variantId;
      // update the variant id in the add to cart button
      if (variantId) {
        currentVariantId = variantId;
        if (addToCartButton) {
          addToCartButton.dataset.addToCartButton = variantId;
        }

        // update the vendor variant id in the add to cart button
        const allVendorVariantIds = node.querySelectorAll('[data-vendor-variant-id]');
        allVendorVariantIds.forEach((vendorVariantId) => {
          if (vendorVariantId.dataset.vendorVariantId === variantId) {
            vendorVariantId.classList.remove('hidden');
          } else {
            vendorVariantId.classList.add('hidden');
          }
        });
      }
    }

    allColors.forEach((color) => {
      color.classList.remove('swatch-selected');
    });

    setTimeout(() => {
      elementSelected.classList.add('swatch-selected');
    }, 300);

    if (selectedImage) {
      // productCardSwiper.slideTo(selectedImage.dataset.imageIndex);
      // hide all slides that don't match the data-image-option1 attribute value
      const allSlides = node.querySelectorAll('.swiper-slide');
      let positionFirstVisibleSlide = -1;
      allSlides.forEach((slide) => {
        if (slide.dataset.imageOption !== selectedImage.dataset.imageOption) {
          slide.classList.add('hidden');
        } else {
          slide.classList.remove('hidden');
          if (positionFirstVisibleSlide === -1) {
            positionFirstVisibleSlide = slide.dataset.imageIndex;
          }
        }
      });
      // refresh the swiper
      productCardSwiper.update();
      productCardSwiper.slideTo(positionFirstVisibleSlide);
    }
  };

  const handleAddToCart = async (e) => {
    e.preventDefault();

    const variantId = addToCartButton.dataset.addToCartButton;

    window.location.href = `${language}/products/${productHandle}?variant=${variantId}`;
  };

  /**
   * Init
   */
  const init = () => {
    if (swiperContainer) initSwiper();

    allColors.forEach((color) => {
      color.addEventListener('click', handleColorClick);
    });

    if (addToCartButton) {
      addToCartButton.addEventListener('click', handleAddToCart);
    }
  };

  init();
};
